import { render, staticRenderFns } from "./passwd.vue?vue&type=template&id=7cf1deb9&scoped=true"
import script from "./passwd.vue?vue&type=script&lang=js"
export * from "./passwd.vue?vue&type=script&lang=js"
import style0 from "./passwd.vue?vue&type=style&index=0&id=7cf1deb9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf1deb9",
  null
  
)

export default component.exports